import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import * as AnalysisStridesSelectors from '../selectors/analysis-strides.selectors';
import * as AnalysisStridesActions from '../actions/analysis-strides.actions';
import * as AnalysisStridesStore from '../reducers/analysis-strides.reducer';
import { ErrorStore, StridesStoreItem } from '@sleipai/sleip-models';

@Injectable({
  providedIn: 'root',
})
export class AnalysisStridesStoreFacade {
  constructor(private readonly store: Store<AnalysisStridesStore.State>) {}

  currentAnalysisStridesEntityLoaded$ = (id: string) =>
    this.store.pipe(
      select(AnalysisStridesSelectors.selectAnalysisStridesById(id)),
      map(
        (stridesStoreItem: StridesStoreItem | null) => stridesStoreItem !== null
      )
    );

  loadAnalysisStridesById$(recordingId: string, isFlexion: boolean) {
    return this.store.dispatch(
      AnalysisStridesActions.loadAnalysisStridesById({
        recordingId,
        isFlexion,
      })
    );
  }

  getCurrentAnalysisStridesEntityById$ = (id: string) =>
    this.store.pipe(
      select(AnalysisStridesSelectors.selectAnalysisStridesById(id))
    );

  getMultipleAnalysisStridesItemsByIds$ = (recordingIds: string[]) => {
    return this.store.pipe(
      select(
        AnalysisStridesSelectors.selectMultipleAnalysisStridesByIds(
          recordingIds
        )
      )
    );
  };

  getAnalysisStridesError$: Observable<ErrorStore | null> = this.store.pipe(
    select(AnalysisStridesSelectors.selectAnalysisStridesError)
  );
}
